import { Component, OnDestroy, OnInit } from '@angular/core'
import { ClientService } from 'src/app/services/client.service'
import { BackendService } from 'src/app/services/backend.service'
import { Client, PaymentMethod, PaymentMethodStatus, paymentMethodsPath } from '@parkupp/core'
import { collection, collectionData, Firestore } from '@angular/fire/firestore'
import { Subscription } from 'rxjs'
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead'

@Component({
    selector: 'app-admin-test-payment',
    templateUrl: './admin-test-payment.component.html',
    styleUrls: ['./admin-test-payment.component.scss'],
})
export class AdminTestPaymentComponent implements OnInit, OnDestroy {
    clients: Client[] = []
    clientSearchText = ''
    selectedClient: Client | null = null

    paymentMethods: PaymentMethod[] = []
    paymentMethodsLoaded = false
    selectedPaymentMethod: PaymentMethod | null = null

    amountRands = 1
    loading = false
    result: any = null
    showRawJson = false

    private clientsSub: Subscription | null = null
    private pmSub: Subscription | null = null

    constructor(
        private clientService: ClientService,
        private backendService: BackendService,
        private firestore: Firestore
    ) {}

    ngOnInit(): void {
        this.clientsSub = this.clientService.list().subscribe((clients) => {
            this.clients = clients
        })
    }

    ngOnDestroy(): void {
        this.clientsSub?.unsubscribe()
        this.pmSub?.unsubscribe()
    }

    onClientSelect(event: TypeaheadMatch): void {
        this.selectedClient = event.item as Client
        this.selectedPaymentMethod = null
        this.result = null
        this.loadPaymentMethods(this.selectedClient.$key!)
    }

    private loadPaymentMethods(clientKey: string): void {
        this.pmSub?.unsubscribe()
        this.paymentMethodsLoaded = false
        this.paymentMethods = []
        this.selectedPaymentMethod = null

        const ref = collection(this.firestore, paymentMethodsPath(clientKey))
        this.pmSub = collectionData(ref, { idField: 'documentId' }).subscribe((docs: any[]) => {
            const cards: PaymentMethod[] = []
            let primary: PaymentMethod | null = null

            docs.forEach((d) => {
                const pm = new PaymentMethod(d)
                pm.$key = d.documentId
                if (pm.status === PaymentMethodStatus.active) {
                    cards.push(pm)
                    if (pm.primary) primary = pm
                }
            })

            this.paymentMethods = cards
            this.selectedPaymentMethod = primary || cards[0] || null
            this.paymentMethodsLoaded = true
        })
    }

    selectCard(pm: PaymentMethod): void {
        this.selectedPaymentMethod = pm
        this.result = null
    }

    get isAmountValid(): boolean {
        return this.amountRands >= 0.01 && this.amountRands <= 10
    }

    async submitTestPayment(): Promise<void> {
        if (!this.selectedClient || !this.selectedPaymentMethod || !this.isAmountValid) return

        this.loading = true
        this.result = null

        try {
            const amountInCents = Math.round(this.amountRands * 100)
            this.result = await this.backendService.httpAdminTestTokenPayment(
                this.selectedClient.$key!,
                this.selectedPaymentMethod.$key!,
                amountInCents
            )
        } catch (e: any) {
            this.result = { error: true, message: e?.message || 'Request failed' }
        } finally {
            this.loading = false
        }
    }
}
